import React from 'react'

import { Col, Row } from '_zari/core'

import * as FormGroups from './formGroups'

const InfoUsuarioSection = ({ username }) => {
  return (
    <Row>
      <Col md={6}>
        <FormGroups.UsernameFormGroup iValue={username} />
      </Col>
    </Row>
  )
}

export default React.memo(InfoUsuarioSection)
